export const SourcingIcon = ({
  size = 24,
  color = 'currentColor',
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 38 38"
      fill="none"
      {...props}
    >
      <path
        d="M15.2 8.54999C15.2 6.45406 16.904 4.74999 19 4.74999C21.0959 4.74999 22.8 6.45406 22.8 8.54999V11.4H15.2V8.54999ZM12.35 11.4H8.54995C6.97651 11.4 5.69995 12.6766 5.69995 14.25V26.6C5.69995 29.7469 8.25308 32.3 11.4 32.3H26.6C29.7468 32.3 32.3 29.7469 32.3 26.6V14.25C32.3 12.6766 31.0234 11.4 29.45 11.4H25.65V8.54999C25.65 4.87468 22.6753 1.89999 19 1.89999C15.3246 1.89999 12.35 4.87468 12.35 8.54999V11.4ZM13.775 14.25C14.5646 14.25 15.2 14.8853 15.2 15.675C15.2 16.4647 14.5646 17.1 13.775 17.1C12.9853 17.1 12.35 16.4647 12.35 15.675C12.35 14.8853 12.9853 14.25 13.775 14.25ZM22.8 15.675C22.8 14.8853 23.4353 14.25 24.225 14.25C25.0146 14.25 25.65 14.8853 25.65 15.675C25.65 16.4647 25.0146 17.1 24.225 17.1C23.4353 17.1 22.8 16.4647 22.8 15.675Z"
        fill={color}
      />
    </svg>
  );
};

export default SourcingIcon;
